import PropTypes from 'prop-types'
import { CheckIcon } from '@phosphor-icons/react'

import Tooltip from '../Tooltip'

const SwitchInput = ({ columnSize, name, value, options, label, tooltip, setFieldValue }) => {
  return (
    <div className={`column is-${columnSize}`}>
      <div className="event-form-switch-input-container">
        <div className="label-container">
          <p>{label}</p>
          <Tooltip name={name} tooltip={tooltip} />
        </div>
        <div className="event-form-switch-input">
          {options.map((option) => {
            const optionSelected = value === option.value
            const optionClassName = `switch-option ${optionSelected ? 'switch-option--selected' : ''}`
            const optionSelectedIconClassName = `switch-option-selected-icon switch-option-selected-icon--${optionSelected ? 'visible' : 'hidden'}`

            return (
              <div
                className={optionClassName}
                key={option.text}
                onClick={() => setFieldValue(name, option.value)}
              >
                <span className={optionSelectedIconClassName}>
                  <CheckIcon />
                </span>
                {option.text}{' '}
                <Tooltip
                  name={option.text}
                  tooltip={option.tooltips.map((tooltip) => <p>{tooltip}</p>)}
                  place="bottom"
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

SwitchInput.propTypes = {
  columnSize: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.array,
  options: PropTypes.array,
}

export default SwitchInput
